import { render, staticRenderFns } from "./accessDetail.vue?vue&type=template&id=61fbc700&scoped=true&"
import script from "./accessDetail.vue?vue&type=script&lang=js&"
export * from "./accessDetail.vue?vue&type=script&lang=js&"
import style0 from "./accessDetail.vue?vue&type=style&index=0&id=61fbc700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fbc700",
  null
  
)

export default component.exports